import HelpIconButton from "../../Components/Buttons/Iconbuttons/HelpIconButton";
import TextField from "@mui/material/TextField";
import { useId, useState } from "react";

export default function FormTextField({
  fieldState,
  fieldLabel,
  modalTitle,
  modalDescription,
  onChange,
  isNumber = false,
  onBlur = () => null,
  onFocus = () => null,
  modalOff = false,
  errorFound = false,
  helperText = "",
  inputProps,
  disabled = false,
  formatValueWhenBlurred,
}) {
  const fieldId = useId();
  const [isFocused, setIsFocused] = useState(false);
  const displayedValue =
    !isFocused && typeof formatValueWhenBlurred === "function"
      ? formatValueWhenBlurred(fieldState)
      : fieldState ?? "";

  return (
    <div className="mb-4 flex w-full items-start gap-2">
      <TextField
        error={errorFound}
        disabled={disabled}
        helperText={helperText}
        size="small"
        sx={{ color: "#666666", width: "100%", maxWidth: "320px" }}
        id={fieldId}
        label={fieldLabel}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        variant="outlined"
        onBlur={(event) => {
          setIsFocused(false);
          onBlur(event.target.value);
        }}
        value={displayedValue}
        type={isNumber ? "number" : "text"}
        inputProps={inputProps}
        onFocus={(event) => {
          setIsFocused(true);
          onFocus(event);
        }}
      />

      {!modalOff && (
        <HelpIconButton title={modalTitle} description={modalDescription} />
      )}
    </div>
  );
}
